// extracted by mini-css-extract-plugin
export default {"navigateBtnCol":"specialNoteDetails_navigateBtnCol__5xoe7","dividerLine":"specialNoteDetails_dividerLine__qZ8KJ"};